import { useRouter } from 'next/router';

import { APPLICATION_CONTENT_ROUTE } from '@framework/constants/enums';

const usePage = () => {
    const { pathname } = useRouter() || {};
    const isEditorView = pathname?.includes(APPLICATION_CONTENT_ROUTE.EDITOR);
    const isAttendeeView = !isEditorView && pathname?.includes(APPLICATION_CONTENT_ROUTE.ATTENDEE);
    const isAdminPortalView = pathname?.includes(APPLICATION_CONTENT_ROUTE.ADMIN_PORTAL);
    const isRoomCreationView = pathname?.includes(APPLICATION_CONTENT_ROUTE.ROOM_CREATION);
    const isRoomEditView = pathname?.includes(APPLICATION_CONTENT_ROUTE.ROOM_EDIT);

    return {
        isEditorView,
        isAttendeeView,
        isAdminPortalView,
        isRoomCreationView,
        isRoomEditView
    };
};

export default usePage;
